import { computed } from 'vue'
import type { ComputedRef } from 'vue'

import { usePermissionsStore } from '@/pinia-store/usePermissionsStore'
import { AuthorizationPermissions, AuthorizationResourcesAndSubjects } from '@/types/authorization'

/**
 * Pode REVERTER a validação de um registro de plantão (`attendance_advanced_receiving`)
 * em algum recurso do ds_attendance — escala, unidade ou empresa, exatamente como
 * `useCanAuditAttendance` faz para a decisão.
 *
 * Varrer os três recursos não é preciosismo: `checkAnyRessources` compara
 * `key.split(':')[0]` com o `resourceType`, sem percorrer o grafo do SpiceDB. Já o
 * `/users/me/permissions` só emite chaves `ds_attendance:<scheduleId>` para escalas
 * que o usuário alcança por leitura — enquanto `advanced_receiver` concedido na
 * empresa/unidade vive sob `ds_attendance_company:<id>` / `ds_attendance_health_unit:<id>`.
 * Exigir o recurso exato escondia o botão de quem tem o papel no escopo mais amplo,
 * embora o endpoint (que resolve container → escala e herda por `company_parent`/
 * `hu_parent`) fosse autorizar a chamada.
 */
export function useCanRevertValidation(): ComputedRef<boolean> {
  const permissionsStore = usePermissionsStore()
  return computed(() =>
    [
      AuthorizationResourcesAndSubjects.DsAttendance,
      AuthorizationResourcesAndSubjects.DsAttendanceHealthUnit,
      AuthorizationResourcesAndSubjects.DsAttendanceCompany
    ].some((resourceType) =>
      permissionsStore.checkAnyRessources({
        permission: AuthorizationPermissions.AttendanceAdvancedReceiving,
        resourceType
      })
    )
  )
}
